import ApiService from './ApiService'
import { Auth0Provider } from '../adapters/Auth0Provider'

/**
 * Factory pour créer une instance d'ApiService configurée
 */
export function createApiService(): ApiService {
  const authProvider = new Auth0Provider()

  const config = {
    baseURL: __BASE_URL_API__ + '/api/',
    timeout: 10000,
    maxRetries: 1,
    retryDelay: 1000
  }

  return new ApiService(authProvider, config)
}

/**
 * Instance singleton d'ApiService pour l'application
 */
export const apiService = createApiService()
